export default () => new Date();
